import { Tooltip } from '@fluentui/react-components';
import styled, { css, keyframes } from 'styled-components';

const tableFirstRow = css`
  width: 20%;
  padding-left: 10px;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};

  button {
    display: none;
  }
`;

const tableFirstRowMobile = css`
  width: 163px;
  padding-left: 10px;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};
  word-wrap: break-word;

  button {
    display: none;
  }
`;

const tableLastRow = css`
  width: 7%;
  background-color: ${(props) =>
    props.theme.timesheetsTableBodyHoursBackground};
  text-align: center;
  vertical-align: middle;

  p {
    color: ${(props) => props.theme.timesheetsSumHoursColor};
  }
  button {
    display: none;
  }
`;

const tableLastRowMobile = css`
  width: 100px;
  background-color: ${(props) =>
    props.theme.timesheetsTableBodyHoursBackground};
  text-align: center;
  vertical-align: middle;

  p {
    color: ${(props) => props.theme.timesheetsSumHoursColor};
  }
  button {
    display: none;
  }
`;

const openCallout = css`
  text-align: center;
  vertical-align: middle;
  position: relative;
  background: ${(props) => props.theme.timesheetsTableCellBackgroundHover};
  p,
  div {
    display: none;
  }
  button {
    display: inline;
  }
`;

const tableRow = css`
  height: 20px;
  width: 7%;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};
  position: relative;
  font-size: 16px;

  button {
    display: none;
  }

  &:hover,
  &:focus,
  &:focus-within,
  &:target {
    p,
    div {
      display: none;
    }
    button {
      display: inline;
    }
    background: ${(props) => props.theme.timesheetsTableCellBackgroundHover};
  }
`;

const tableRowMobile = css`
  height: 20px;
  width: 100px;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};
  position: relative;
  font-size: 16px;

  button {
    display: none;
  }

  &:hover,
  &:focus,
  &:focus-within,
  &:target {
    p,
    div {
      display: none;
    }
    button {
      display: inline;
    }
    background: ${(props) => props.theme.timesheetsTableCellBackgroundHover};
  }
`;

const tableRowNonWorkday = css`
  height: 20px;
  width: 7%;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) =>
    props.theme.timesheetsNonWorkingDayCellBackgorund};
  position: relative;
  font-size: 16px;

  button {
    display: none;
  }

  &:hover,
  &:focus,
  &:focus-within,
  &:target {
    p,
    div {
      display: none;
    }
    button {
      display: inline;
    }
    background: ${(props) => props.theme.timesheetsTableCellBackgroundHover};
  }
`;

const tableRowNonWorkdayMobile = css`
  height: 20px;
  width: 100px;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) =>
    props.theme.timesheetsNonWorkingDayCellBackgorund};
  position: relative;
  font-size: 16px;

  button {
    display: none;
  }

  &:hover,
  &:focus,
  &:focus-within,
  &:target {
    p,
    div {
      display: none;
    }
    button {
      display: inline;
    }
    background: ${(props) => props.theme.timesheetsTableCellBackgroundHover};
  }
`;

export const isUnavailable = css`
  height: 20px;
  width: 7%;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};
  position: relative;
`;

export const isUnavailableMobile = css`
  height: 20px;
  width: 100px;
  text-align: center;
  vertical-align: middle;
  background-color: ${(props) => props.theme.timesheetsTableBodyBackground};
  position: relative;
`;

export const TableRowBodyCell = styled.td<{
  firstRow: boolean;
  lastRow: boolean;
  unAvailableEntry: boolean;
  isCalloutVisible: boolean;
  isWorkday: boolean;
  isMobile?: boolean;
}>`
  ${({
    firstRow,
    lastRow,
    unAvailableEntry,
    isCalloutVisible,
    isWorkday,
    isMobile,
  }) => {
    if (firstRow) {
      if (isMobile) {
        return tableFirstRowMobile;
      } else {
        return tableFirstRow;
      }
    } else if (lastRow) {
      if (isMobile) {
        return tableLastRowMobile;
      } else {
        return tableLastRow;
      }
    } else if (unAvailableEntry) {
      if (isMobile) {
        return isUnavailableMobile;
      } else {
        return isUnavailable;
      }
    } else if (isCalloutVisible) {
      return openCallout;
    } else {
      if (isWorkday) {
        if (isMobile) {
          return tableRowMobile;
        } else {
          return tableRow;
        }
      } else {
        if (isMobile) {
          return tableRowNonWorkdayMobile;
        } else {
          return tableRowNonWorkday;
        }
      }
    }
  }}
  border: 1px solid ${(props) => props.theme.timesheetsTableBorderColor};
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
`;

export const TableRowCellText = styled.p`
  font-weight: 700;
`;

const hourPillsNone = css`
  display: none;
`;

const hourPills = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
  width: 55px;
  background-color: ${(props) => props.theme.timesheetsHourPillsBackground};
  border-radius: 1rem;
  padding: 0.2rem 0.6rem;
  font-size: 0.85rem;
  font-weight: 400;
  margin: 5px auto;
`;

export const HourPill = styled.div<{ showHourPills: boolean }>`
  ${({ showHourPills }) => {
    if (!showHourPills) {
      return hourPillsNone;
    } else {
      return hourPills;
    }
  }}
`;

const statusCompleted = css`
  background-color: #6bb700;
`;

const statusUncompleted = css`
  background-color: #ffb64e;
`;

const statusDisabled = css`
background-color: #b3b3b3;
`;

export const Status = styled.div<{ isCompleted: boolean, isDisabled: boolean }>`
  ${({ isCompleted, isDisabled }) => {
    if (isDisabled) return statusDisabled;
    if (isCompleted) {
      return statusCompleted;
    } else {
      return statusUncompleted;
    }
  }}
  height: 0.6rem;
  width: 0.6rem;
  border-radius: 50%;
`;

export const UnavaliableDayEntry = styled.div`
  width: 20px;
  height: 1px;
  border-radius: 10px;
  background-color: ${(props) => props.theme.timesheetsTableTextMainColor};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const TimeOffDayEntry = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
`;

export const TimesheetsTooltip = styled(Tooltip)`
  width: 500px;
`;

const fadeOutAnimation = keyframes`
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
`;

export const SuccessOverlay = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  animation-name: ${fadeOutAnimation};
  animation-timing-function: ease-out;
  animation-duration: 2s;
  background-color: ${(props) => props.theme.timesheetsSuccessOverlay};
`;
